/* eslint-disable jsx-a11y/anchor-is-valid */
import clsx from 'clsx'
import {FC} from 'react'
import {toAbsoluteUrl} from '../../../../../../../../../_metronic/helpers'
import {Leave} from '../../core/_models'

type Props = {
  leave: Leave
}

const LeaveInfoCell: FC<Props> = ({leave}) => (
  <div className='d-flex align-items-center'>
    {/* begin:: Avatar */}
    <div className='symbol symbol-circle symbol-50px overflow-hidden me-3'>
      <a href='#'>
        {leave.avatar ? (
          <div className='symbol-label'>
            <img src={toAbsoluteUrl(`/media/${leave.avatar}`)} alt={leave.name} className='w-100' />
          </div>
        ) : (
          <div
            className={clsx(
              'symbol-label fs-3',
              `bg-light-${leave.initials?.state}`,
              `text-${leave.initials?.state}`
            )}
          >
            {leave.initials?.label}
          </div>
        )}
      </a>
    </div>
    <div className='d-flex flex-column'>
      <a href='#' className='text-gray-800 text-hover-primary mb-1'>
        {leave.name}
      </a>
      <span>{leave.email}</span>
    </div>
  </div>
)

export {LeaveInfoCell}
